import { motion } from 'framer-motion';
import { useNavigate } from 'react-router-dom';
import GlassCard from '../ui/GlassCard';
import GlassButton from '../ui/GlassButton';

export default function Pricing() {
    const navigate = useNavigate();

    const plans = [
        {
            name: "Student Plan",
            price: "$49",
            period: "/ lifetime",
            features: [
                "Unlimited AI Interviews",
                "Performance Analytics",
                "Basic Speech Analysis",
                "Industry-specific Sets"
            ],
            highlight: false
        },
        {
            name: "Premium",
            price: "$29",
            period: "/ month",
            features: [
                "Everything in Student",
                "Advanced Body Language AI",
                "Video Recording Storage",
                "Priority Support"
            ],
            highlight: true
        },
        {
            name: "B2B & Corporate",
            price: "Custom",
            period: "",
            features: [
                "Bulk Management",
                "Full Team Analytics",
                "Custom Branding",
                "Dedicated Success Manager"
            ],
            highlight: false
        }
    ];

    return (
        <section id="pricing" className="py-32 relative">
            <div className="max-w-7xl mx-auto px-6">
                <motion.div
                    initial={{ opacity: 0, y: 20 }}
                    whileInView={{ opacity: 1, y: 0 }}
                    viewport={{ once: true }}
                    className="text-center mb-20"
                >
                    <h2 className="text-4xl md:text-5xl font-bold mb-6">
                        Simple, Transparent <br />
                        <span className="text-gradient">Pricing</span>
                    </h2>
                    <p className="text-zinc-400 max-w-xl mx-auto text-lg">
                        Choose the specific plan that fits your interview preparation needs.
                    </p>
                </motion.div>

                <div className="grid grid-cols-1 md:grid-cols-3 gap-8 items-start">
                    {plans.map((plan, index) => (
                        <GlassCard
                            key={index}
                            delay={index * 0.1}
                            gradient={plan.highlight}
                            className={`relative ${plan.highlight ? 'border-blue-500/[0.3]' : ''}`}
                        >
                            {plan.highlight && (
                                <div className="absolute top-0 right-0 p-4">
                                    <span className="bg-blue-500 text-white text-xs font-bold px-3 py-1 rounded-full">POPULAR</span>
                                </div>
                            )}

                            <h3 className={`text-xl font-bold mb-2 ${plan.highlight ? 'text-blue-400' : 'text-zinc-400'}`}>
                                {plan.name}
                            </h3>
                            <div className="flex items-baseline gap-1 mb-8">
                                <span className="text-5xl font-bold text-white">{plan.price}</span>
                                <span className="text-zinc-500">{plan.period}</span>
                            </div>

                            <ul className="space-y-4 mb-8">
                                {plan.features.map((feature, i) => (
                                    <li key={i} className="flex items-center gap-3 text-zinc-300">
                                        <i className="ri-check-line text-green-400"></i>
                                        {feature}
                                    </li>
                                ))}
                            </ul>

                            <GlassButton
                                variant={plan.highlight ? 'primary' : 'outline'}
                                className="w-full"
                                onClick={() => navigate('/login')}
                            >
                                {plan.price === "Custom" ? "Contact Sales" : "Get Started"}
                            </GlassButton>
                        </GlassCard>
                    ))}
                </div>
            </div>
        </section>
    );
}
